import { withVersions } from "v2/hocs/withVersions";
import { withCrossChainDeposit } from "../hocs/withCrossChainDeposit";
import CrossChainDepositV1 from "./CrossChainDeposit/v1";
import CrossChainDepositV2 from "./CrossChainDeposit/v2";

const CrossChainDepositModal = withVersions({
  v1: withCrossChainDeposit(CrossChainDepositV1),
  v2: withCrossChainDeposit(CrossChainDepositV2),
});

export { CrossChainDepositModal };
